// Shared source of truth for default TOS and Privacy Policy text.
// TermsScreen / PrivacyScreen (user-facing) and LegalContentTab (admin editor) import
// from here so they always show the same content when Firestore has no override.
// The text lives in legalText.json and the version in legalVersion.js so
// scripts/maintenance/legalContent.js (Node, CommonJS) publishes exactly the same
// text and version to site_config/legal_content.
import legalText from './legalText.json';

export { TERMS_VERSION } from './legalVersion';
export const DEFAULT_TOS = legalText.tos;
export const DEFAULT_PRIVACY = legalText.privacyPolicy;
